import { FeatureType } from "@seneca/trials-service-client/dist/types";

import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import { PREMIUM_TRIALS_STATE_SLICE_PATH } from "../consts";
import PremiumTrialsStateSlice from "../models/state/PremiumTrialsStateSlice";
import TrialState from "../models/state/trials/trial/TrialState";
import * as stateSliceSelectors from "./state";

export function getPremiumTrialsStateSlice(
  state: any
): PremiumTrialsStateSlice {
  return state.get(PREMIUM_TRIALS_STATE_SLICE_PATH);
}

// wrong answers trial

// @ts-ignore
export const getTrialsState: (arg0: any) => TrialState = composeSelector(
  getPremiumTrialsStateSlice,
  stateSliceSelectors.getTrialsState
);

export const hasWrongAnswersPremiumTrial: (arg0: any) => boolean =
  composeSelector(
    getPremiumTrialsStateSlice,
    stateSliceSelectors.hasWrongAnswersPremiumTrial
  );

export const getWrongAnswersSessionsInitiallyGranted: (arg0: any) => number =
  composeSelector(
    getPremiumTrialsStateSlice,
    stateSliceSelectors.getWrongAnswersSessionsInitiallyGranted
  );

export const getWrongAnswersSessionsRemaining: (arg0: any) => number =
  composeSelector(
    getPremiumTrialsStateSlice,
    stateSliceSelectors.getWrongAnswersSessionsRemaining
  );

export const canStudyWrongAnswersSession: (arg0: any) => boolean =
  composeSelector(
    getPremiumTrialsStateSlice,
    stateSliceSelectors.canStudyWrongAnswersSession
  );

export const userHasFinishedWrongAnswersTrial: (arg0: any) => boolean =
  composeSelector(
    getPremiumTrialsStateSlice,
    stateSliceSelectors.userHasFinishedWrongAnswersTrial
  );

// meta

// fetch
export const trialsAreFetching: (arg0: any) => boolean = composeSelector(
  getPremiumTrialsStateSlice,
  stateSliceSelectors.trialsAreFetching
);
export const trialsFetchSucceeded: (arg0: any) => boolean = composeSelector(
  getPremiumTrialsStateSlice,
  stateSliceSelectors.trialsFetchSucceeded
);
export const trialsFetchErrored: (arg0: any) => boolean = composeSelector(
  getPremiumTrialsStateSlice,
  stateSliceSelectors.trialsFetchErrored
);
export const trialsFetchFinished: (arg0: any) => boolean = composeSelector(
  getPremiumTrialsStateSlice,
  stateSliceSelectors.trialsFetchFinished
);
export const trialsNeedFetching: (arg0: any) => boolean = composeSelector(
  getPremiumTrialsStateSlice,
  stateSliceSelectors.trialsNeedFetching
);
// update
export const trialIsUpdating: (arg0: any) => boolean = composeSelector(
  getPremiumTrialsStateSlice,
  stateSliceSelectors.trialIsUpdating
);
export const trialUpdateSucceeded: (arg0: any) => boolean = composeSelector(
  getPremiumTrialsStateSlice,
  stateSliceSelectors.trialUpdateSucceeded
);
export const trialUpdateErrored: (arg0: any) => boolean = composeSelector(
  getPremiumTrialsStateSlice,
  stateSliceSelectors.trialUpdateErrored
);

const makeWrongAnswersTrialMetaSelector = (selector: any) => (state: any) =>
  selector(state, FeatureType.WRONG_ANSWERS);

export const wrongAnswersTrialIsUpdating =
  makeWrongAnswersTrialMetaSelector(trialIsUpdating);
export const wrongAnswersTrialUpdateSucceeded =
  makeWrongAnswersTrialMetaSelector(trialUpdateSucceeded);
export const wrongAnswersTrialUpdateErrored =
  makeWrongAnswersTrialMetaSelector(trialUpdateErrored);
